module.exports = __webpack_public_path__ + "static/media/img_kaufmann.b81ceaa5.png";